// Action type constants extracted to break circular dependency between
// actions.ts <-> GRPCSubscriptionPagedList.ts / GRPCSubscriptionObject.ts / reducer.ts

export const SUBSCRIBE_OBJECT = 'SUBSCRIBE_OBJECT'
export const UNSUBSCRIBE = 'UNSUBSCRIBE'
export const LOADED = 'LOADED'
export const RESET_LIST = 'RESET'
export const ERRORED = 'ERRORED'
export const LOADING = 'LOADING'

// TODO: heap or trie or something for invalidation tags

export const SUBSCRIBE_LIST = 'SUBSCRIBE_LIST'
export const ADD_TO_LIST = 'ADD_TO_LIST'
export const INVALIDATE_TAG = 'INVALIDATE_TAG'
export const INVALIDATE_TAGS = 'INVALIDATE_TAGS'
export const DELETE_FROM_LIST = 'DELETE_FROM_LIST'
export const MODIFY_LIST = 'MODIFY_LIST'
export const MARK_DIRTY = 'MARK_DIRTY'
export const RESET_LIST_LOADING = 'RESET_LIST_LOADING'

export type ACTIONS =
    | typeof SUBSCRIBE_OBJECT
    | typeof UNSUBSCRIBE
    | typeof LOADED
    | typeof ERRORED
    | typeof SUBSCRIBE_LIST
    | typeof ADD_TO_LIST
    | typeof DELETE_FROM_LIST
    | typeof MODIFY_LIST
    | typeof INVALIDATE_TAG
    | typeof LOADING
    | typeof RESET_LIST
    | typeof MARK_DIRTY
    | typeof RESET_LIST_LOADING
    | typeof INVALIDATE_TAGS
